module.exports = __webpack_public_path__ + "img/B_SEN_ASGIVA_Logo_DE_H_PW_RGB.d2ac9dd8.png";